import type {DIContainerFactory} from '../../../../IoC/containerFactories/types';

import {ContainerBinder} from '../../../../IoC/ContainerBinder';
import {CromModelFactory} from '../domain/Crom/CromModel.factory';
import {CromSolvingStore} from '../stores/CromSolving.store';
import {FetchCromByIdUseCase} from '../useCases/FetchCromById.uc';
import {SendCromAnswersUseCase} from '../useCases/SendCromAnswers.uc';
import {bindJrpc} from './bind.jrpc';

export const cromsFeatureContainerFactoryJrpc: DIContainerFactory = ({
  containerToBind = ContainerBinder.createContainer(),
} = {}) => {
  cromsFeatureBindDomain(containerToBind);
  cromsFeatureBindUseCases(containerToBind);
  cromsFeatureBindStores(containerToBind);
  bindJrpc(containerToBind);

  return containerToBind;
};

const cromsFeatureBindDomain = (container: ContainerBinder.Container) => {
  return new ContainerBinder(container).bindSingleton(CromModelFactory).done();
};

const cromsFeatureBindUseCases = (container: ContainerBinder.Container) => {
  return new ContainerBinder(container)
    .bindSingleton(SendCromAnswersUseCase)
    .bindSingleton(FetchCromByIdUseCase)
    .done();
};

const cromsFeatureBindStores = (container: ContainerBinder.Container) => {
  return new ContainerBinder(container).bindSingleton(CromSolvingStore).done();
};
